const RECENTLY_VIEWED_KEY = 'recently-viewed-products';
const MAX_STORED_PRODUCTS = 20;

class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    const storedHandles = this.getStoredHandles();
    const currentHandle = this.dataset.productHandle;

    if (currentHandle) this.storeHandle(currentHandle, storedHandles);

    const limit = parseInt(this.dataset.limit, 10) || 8;
    this.handles = storedHandles.filter(handle => handle !== currentHandle).slice(0, limit);

    if (this.handles.length === 0) return;

    this.loadProducts();
  }

  getStoredHandles() {
    try {
      const handles = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY));
      return Array.isArray(handles) ? handles : [];
    }
    catch {
      return [];
    }
  }

  storeHandle(handle, storedHandles) {
    const handles = [handle, ...storedHandles.filter(storedHandle => storedHandle !== handle)].slice(0, MAX_STORED_PRODUCTS);

    try {
      localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(handles));
    }
    catch {
      // localStorage can be unavailable (e.g. blocked cookies); viewing history is then simply not tracked
    }
  }

  loadProducts() {
    const query = this.handles.map(handle => `handle:${handle}`).join(' OR ');

    fetch(`${this.dataset.url}&q=${encodeURIComponent(query)}`)
      .then(response => response.text())
      .then((text) => {
        const fetchedProducts = document.createRange().createContextualFragment(text).querySelector('[data-recommended-products]');
        const target = this.querySelector('[data-recommended-products]');

        if (!fetchedProducts || !target || fetchedProducts.children.length === 0) return;

        // Search returns results in relevance order; restore most-recently-viewed order
        const slides = Array.from(fetchedProducts.children);
        const orderedSlides = this.handles
          .map(handle => slides.find(slide => slide.querySelector(`a[href$="/products/${handle}"], a[href*="/products/${handle}?"]`)))
          .filter(Boolean);
        const remainingSlides = slides.filter(slide => !orderedSlides.includes(slide));

        target.replaceChildren(...orderedSlides, ...remainingSlides);
        this.hidden = false;

        window.initDialogs?.(this);
      })
      .catch((event) => {
        debug() && console.error(event);
      });
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
